// extracted by mini-css-extract-plugin
export default {"item":"WSMenu-module_item-oC8GN","icon":"WSMenu-module_icon-QNYkr","destructive":"WSMenu-module_destructive-tuknz","sidebar":"WSMenu-module_sidebar-YH0kB"};